module.exports = {
  PORT: "3124",
  NODE_ENV: "staging",

  SERVER_DEV_URL: "http://localhost:3123",
  SERVER_STAGING_URL: "https://marriotcharitygolf-api.cloudxier.dev",
  SERVER_PROD_URL: "https://marriotcharitygolf-api.cloudxier.com",

  CLIENT_DEV_HOST: "localhost",
  CLIENT_STAGING_HOST: "marriotcharitygolf.cloudxier.dev",
  CLIENT_PROD_HOST: "marriotgolf.bigeventasia.id",

  CLIENT_DEV_URL: "http://localhost:3000",
  CLIENT_STAGING_URL: "https://marriotcharitygolf.cloudxier.dev",
  CLIENT_PROD_URL: "https://marriotgolf.bigeventasia.id",

  MAIN_WEBSITE_TITLE: "MARRIOTT | ",
  SITE_NAME: "MARRIOTT Charity Golf Tournament 2025",
};
